var _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubleOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 3.5,
    width: 5,
    height: 9,
    rx: 0.5,
    stroke: "#09090B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 3.5,
    width: 5,
    height: 9,
    rx: 0.5,
    stroke: "#09090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleOutline);
export default __webpack_public_path__ + "static/media/doubleOutline.e65f97767aca6440bab33e3d9b59b71e.svg";
export { ForwardRef as ReactComponent };